// Sample a closed heart by distance so balloons stay evenly spaced at the tip and lobes.
export function heartOutline(width, height) {
  const size = Math.min(width * 0.78, height * 0.58, 640);
  return Array.from({ length: 361 }, (_, index) => {
    const t = index / 360 * Math.PI * 2;
    return {
      x: width / 2 + size * (16 * Math.sin(t) ** 3) / 32,
      y: height * 0.53 - size * (13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t) + 2.5) / 32
    };
  });
}

export function evenlySpacedPoints(outline, count) {
  const distances = [0];
  for (let i = 1; i < outline.length; i++) {
    distances.push(distances[i - 1] + Math.hypot(outline[i].x - outline[i - 1].x, outline[i].y - outline[i - 1].y));
  }
  let segment = 1;
  return Array.from({ length: count }, (_, index) => {
    const distance = index * distances[distances.length - 1] / count;
    while (segment < distances.length - 1 && distances[segment] < distance) segment++;
    const fraction = (distance - distances[segment - 1]) / (distances[segment] - distances[segment - 1]);
    const a = outline[segment - 1], b = outline[segment];
    return { x: a.x + (b.x - a.x) * fraction, y: a.y + (b.y - a.y) * fraction };
  });
}
